import React, { Component } from "react";
import { callPlayer, getSDK } from "../utils.js";
const SDK_URL = "https://w.soundcloud.com/player/api.js";
const SDK_GLOBAL = "SC";
const MATCH_URL = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
class SoundCloud extends Component {
  constructor() {
    super(...arguments);
    this.callPlayer = callPlayer;
    this.duration = null;
    this.currentTime = null;
    this.fractionLoaded = null;
    this.mute = () => {
      this.setVolume(0);
    };
    this.unmute = () => {
      if (this.props.volume !== null) {
        this.setVolume(this.props.volume);
      }
    };
    this.ref = (iframe) => {
      this.iframe = iframe;
    };
  }
  load(url, isReady) {
    getSDK(SDK_URL, SDK_GLOBAL).then((SC) => {
      if (!this.iframe) {
        return;
      }
      const { PLAY, PLAY_PROGRESS, PAUSE, FINISH, ERROR } = SC.Widget.Events;
      if (!isReady) {
        this.player = SC.Widget(this.iframe);
        this.player.bind(PLAY, this.props.onPlay);
        this.player.bind(PAUSE, this.props.onPause);
        this.player.bind(PLAY_PROGRESS, (e) => {
          this.currentTime = e.currentPosition / 1e3;
          this.fractionLoaded = e.loadedProgress;
        });
        this.player.bind(FINISH, () => this.props.onEnded());
        this.player.bind(ERROR, (e) => this.props.onError(e));
      }
      this.player.load(url, {
        ...this.props.config.soundcloud.options,
        callback: () => {
          this.player.getDuration((duration) => {
            this.duration = duration / 1e3;
            this.props.onReady();
          });
        }
      });
    });
  }
  play() {
    this.callPlayer("play");
  }
  pause() {
    this.callPlayer("pause");
  }
  stop() {
  }
  seekTo(seconds) {
    this.callPlayer("seekTo", seconds * 1e3);
  }
  setVolume(fraction) {
    this.callPlayer("setVolume", fraction * 100);
  }
  getDuration() {
    return this.duration;
  }
  getCurrentTime() {
    return this.currentTime;
  }
  getSecondsLoaded() {
    return this.fractionLoaded * this.duration;
  }
  render() {
    const { display } = this.props;
    const style = {
      width: "100%",
      height: "100%",
      display
    };
    return (
      // oxlint-disable-next-line jsx-a11y/iframe-has-title
      /* @__PURE__ */ React.createElement(
        "iframe",
        {
          ref: this.ref,
          src: `https://w.soundcloud.com/player/?url=${encodeURIComponent(this.props.url)}`,
          style,
          frameBorder: 0,
          allow: "autoplay"
        }
      )
    );
  }
}
SoundCloud.displayName = "SoundCloud";
SoundCloud.canPlay = (url) => MATCH_URL.test(url);
SoundCloud.loopOnEnded = true;
export {
  SoundCloud
};
//# sourceMappingURL=soundcloud.js.map
